export default {
  IN_HOUSE_MANUFACTURING: 'IN_HOUSE_MANUFACTURING',
  OUTSOURCED_MANUFACTURING: 'OUTSOURCED_MANUFACTURING',
  IN_HOUSE_PLANNING_ORDER: 'IN_HOUSE_PLANNING_ORDER',
  OUTSOURCED_PLANNING_ORDER: 'OUTSOURCED_PLANNING_ORDER',
  INITIAL_TASK: 'INITIAL_TASK',
  CUSTOM: 'CUSTOM',
} as const
